import React, { useState, useEffect } from 'react';
import { Table, Typography, Tooltip, Button, Row, Col, Modal, Select, Input, message, Popconfirm,Spin} from 'antd';
import ApiService from '../Components/apiService';
import { BASE_URL,DateFormat,DateTimeFormat } from '../Components/Constant';
import Cookies from 'js-cookie';
import { DeleteOutlined, EditOutlined, CopyOutlined } from '@ant-design/icons';
import AccessPolicyDetailPage from './AccessPolicyDetailPage';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import {convertDateToUserTimezone} from '../Components/Utility';

const { Title } = Typography;
const { Option } = Select;

const AccessPolicy = () => {
    const [accessPolicy, setAccessPolicy] = useState([]);
    const [createPolicy, setCreatePolicy] = useState(false);
    const [policyName, setPolicyName] = useState('');
    const [assignedUser, setAssignedUser] = useState(null);
    const [users, setUsers] = useState([]); // Assuming you will fetch users from an API
    const currentUserId = Cookies.get('userId');
    const [showDetailPage,setShowDetailPage]=useState(false);
    const [selectedAccessPolicy,setSelectedAccessPolicy]=useState(null);
    const [loading, setLoading] = useState(true);  // <-- Added loading state
    const [pageSize, setPageSize] = useState(10); 
    const security = useSelector((state) => state.data.items[0]);
    const navigate = useNavigate();



    const fetchData = async () => {
        try {
            setLoading(true); 
            const apiService = new ApiService(
                `${BASE_URL}/mt_access_policies`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const response = await apiService.makeCall(navigate);
            setAccessPolicy(response);
        } catch (error) {
            console.error('Error fetching access policy', error);
        }
        finally {
            setLoading(false);  
        }
    };


    const fetchUsers = async () => {
        try {
            // Replace with the correct API to fetch users
            const apiService = new ApiService(
                `${BASE_URL}/fetch_records/User`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const response = await apiService.makeCall();
            setUsers(response?.records);
        } catch (error) {
            console.error('Error fetching users', error);
        }
    }; 

    useEffect(() => {
        fetchData();
        fetchUsers();
    }, [currentUserId]);

    const handleClick=(policy)=>{
        setShowDetailPage(true);  
        setSelectedAccessPolicy(policy);
    }

    const handleEditPolicy=(policy)=>{
        if(security?.system_settings?.access_policy.edit===false){
            message.error('You dont have permission to edit ');
            return;
        }
        setCreatePolicy(true);
        setSelectedAccessPolicy(policy);
        setPolicyName(policy?.Name);
        setAssignedUser(policy?.assigned_to_ids);
    }

    const handleClonePolicy=(policy)=>{
        if(security?.system_settings?.access_policy.create===false){
            message.error('You dont have permission to create ');
            return;
          }
        setCreatePolicy(true);
        setPolicyName(policy?.Name + ' ' + 'Clone');
        setAssignedUser(policy?.assigned_to_ids);
        setSelectedAccessPolicy(null);
    }

    const deletePolicy=async(policy)=>{
        if(security?.system_settings?.access_policy.delete===false){
            message.error('You dont have permission to delete ');
            return;
          }
        try{
            const apiService = new ApiService(
                `${BASE_URL}/delete_access_policy/${policy._id}`,
                { 'Content-Type': 'application/json' },
                'DELETE'
            );
            const response =await apiService.makeCall();
            message.success('Access Policy Group deleted successfully');
            fetchData();
        }catch(error){
            message.error('Failed to delete access policy group');
        }

    }

    const handleCreatePolicy = () => {
        setSelectedAccessPolicy(null);
        if(security?.system_settings?.access_policy.create===false){
            message.error('You dont have permission to create ');
            return;
          }
        setCreatePolicy(true);
    };

    const handleCancel = () => {
        setCreatePolicy(false);
        setPolicyName('');
        setAssignedUser(null);
    };

    const handleSave =async () => {
        if (!policyName) {
            message.error('Please fill in Name');
            return;
        }
        // Call method to save the policy, assuming you have an API to handle this

        

        try {
            setLoading(true);
            let apiService='';
            if(selectedAccessPolicy?._id){

                selectedAccessPolicy.Name=policyName;
                selectedAccessPolicy.assigned_to_ids=assignedUser;

                apiService = new ApiService(
                    `${BASE_URL}/update_access_policy/${selectedAccessPolicy?._id}`,
                    { 'Content-Type': 'application/json' },
                    'PATCH',selectedAccessPolicy
                );
            }else{

                const body={
                    mt_access_policy:{
                        Name:policyName,
                        assigned_to_ids:assignedUser
                    }
                }
    
                 apiService = new ApiService(
                    `${BASE_URL}/mt_access_policies`,
                    { 'Content-Type': 'application/json' },
                    'POST',body
                );
            }
           
            const response = await apiService.makeCall();
            message.success('Access Policy saved successfully');
            setSelectedAccessPolicy(null);
            fetchData();
        } catch (error) {
            message.error('Error saving access policy');
        }finally{
            setLoading(false);
        }

        // Close the modal
        setCreatePolicy(false);
        setPolicyName('');
        setAssignedUser(null);
    };
 
    const columns = [
        {
            title: 'Name',
            dataIndex: 'Name',
            key: 'Name',
            sorter: (a, b) => a.Name.localeCompare(b.Name),
            render: (text, policy) => (
                <span
                    onClick={() => handleClick(policy)}
                    style={{ color: '#0070d2', cursor: 'pointer' }}
                >
                    {text}
                </span>
            ),
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: 'created_at',
            // width: 100,
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
            render: (text) => (
                text && dayjs(text).isValid()
                  ? convertDateToUserTimezone(text, DateTimeFormat)
                  : ''
              ),
                    
          },
          {
            title: 'Updated At',
            dataIndex: 'updated_at',
            key: 'updated_at',
            // width: 100,
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
            render: (text) => (
                text && dayjs(text).isValid()
                  ? convertDateToUserTimezone(text, DateTimeFormat)
                  : ''
              ),
                    
          },
    ];

    columns.push({
        title: 'Action',
        key: 'operation',
        render: (_, policy) => (
            <>
                <Tooltip title="Edit">
                    <EditOutlined
                        onClick={() => handleEditPolicy(policy)}
                        style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
                    />
                </Tooltip>

                <Tooltip title="Clone">
                    <CopyOutlined
                        onClick={() => handleClonePolicy(policy)}
                        style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
                    />
                </Tooltip>

                <Tooltip title="Delete">
                    <Popconfirm
                        title="Are you sure you want to delete this policy?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => deletePolicy(policy)}
                    >
                        <DeleteOutlined
                            style={{ color: 'red', marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
                        />
                    </Popconfirm>
                </Tooltip>
            </>
        ),
    });

    

    return (
        <div>
            {showDetailPage ? (
                <AccessPolicyDetailPage  
                selectedAccessPolicy={selectedAccessPolicy} 
                users={users}
                onMain={() => setShowDetailPage(false)}
                
                />
            ) : (
                <>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <Row justify="space-between" align="middle" style={{ marginBottom: '16px' }}>
                            <Col>
                                <Title level={4} style={{ margin: 0 }}>
                                    Access Policy
                                </Title>
                            </Col>
                            <Col>
                                <Button type="primary" onClick={handleCreatePolicy}>
                                    Create Access Policy
                                </Button>
                            </Col>
                        </Row>
                    </div>
    
                    <Spin spinning={loading} tip="Loading Access Policies...">
                        <Table columns={columns} dataSource={accessPolicy} scroll={{ x: 'max-content', y: 550 }}
                            pagination={{
                            pageSize: pageSize,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            onChange: (page, pageSize) => {
                                setPageSize(pageSize);
                            },              
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            }}/>
                    </Spin>
    
                    <Modal
                        title="Create Access Policy"
                        visible={createPolicy}
                        onCancel={handleCancel}
                        footer={null}
                        width={600}
                        zIndex={1002}   // higher than sidebar
                    >
                        <Row gutter={16}>
                            <Col span={24}>
                                <div style={{ marginBottom: '16px' }}>
                                    <label>Name</label>
                                    <Input
                                        value={policyName}
                                        onChange={(e) => setPolicyName(e.target.value)}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </Col>
                            <Col span={24}>
                                <div style={{ marginBottom: '16px' }}>
                                    <label>Assigned to</label>
                                    <Select
                                        mode='multiple'
                                        value={assignedUser}
                                        onChange={setAssignedUser}
                                        style={{ width: '100%' }}
                                    >
                                        {users.map((user) => (
                                            <Option key={user._id} value={user._id}>
                                                {user.Name}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                            </Col>
                        </Row>
                        <Row justify="end">
                            <Col>
                                <Button onClick={handleCancel} style={{ marginRight: 8 }}>
                                    Cancel
                                </Button>
                                <Button type="primary" onClick={handleSave}>
                                    Save
                                </Button>
                            </Col>
                        </Row>
                    </Modal>
                </>
            )}
        </div>
    );
    
};

export default AccessPolicy;
